/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, memo } from 'react';
import { getReguladores, getTiposDocumentoBandeja, getRubrosBandeja, getPaisesBandeja } from '../http/actions/BandejaNormativaAction';

const BandejaDataLoader = memo(({ onDataLoaded }) => {
  const [dataLoaded, setDataLoaded] = useState(false);

  const loadData = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      
      const [reguladores, tiposDocumento, rubros, paises] = await Promise.all([
        getReguladores(token),
        getTiposDocumentoBandeja(token),
        getRubrosBandeja(token),
        getPaisesBandeja(token)
      ]);

      onDataLoaded({
        reguladores,
        tiposDocumento,
        rubros,
        paises
      });
      
      setDataLoaded(true);
    } catch (error) {
      console.error("Error loading bandeja data:", error);
      onDataLoaded({
        reguladores: [],
        tiposDocumento: []
      });
    }
  }, [onDataLoaded]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return null;
});

export default BandejaDataLoader;